(function () {
  'use strict';

  var AREA_W    = 150; // total canvas width in cm
  var AREA_H    = 100; // total canvas height in cm
  var GRID_STEP = 25;  // ruler lines every N cm

  function drawPattern(canvas, img, repeatW, repeatH) {
    var ctx = canvas.getContext('2d');
    var pxPerCm = canvas.width / AREA_W;
    canvas.height = Math.round(AREA_H * pxPerCm);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // --- Tile the pattern ---
    var tile = document.createElement('canvas');
    tile.width  = Math.max(1, Math.round(repeatW * pxPerCm));
    tile.height = Math.max(1, Math.round(repeatH * pxPerCm));
    tile.getContext('2d').drawImage(img, 0, 0, tile.width, tile.height);

    var pattern = ctx.createPattern(tile, 'repeat');
    ctx.fillStyle = pattern;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // --- Grid lines every GRID_STEP cm ---
    ctx.strokeStyle = 'rgba(252, 249, 240, 0.55)';
    ctx.lineWidth = 1;
    ctx.setLineDash([5, 5]);

    for (var x = GRID_STEP; x < AREA_W; x += GRID_STEP) {
      ctx.beginPath();
      ctx.moveTo(x * pxPerCm, 0);
      ctx.lineTo(x * pxPerCm, canvas.height);
      ctx.stroke();
    }
    for (var y = GRID_STEP; y < AREA_H; y += GRID_STEP) {
      ctx.beginPath();
      ctx.moveTo(0, y * pxPerCm);
      ctx.lineTo(canvas.width, y * pxPerCm);
      ctx.stroke();
    }
    ctx.setLineDash([]);

    // --- Grid labels --- brand navy #253952
    ctx.font = 'bold 11px Poppins, sans-serif';
    for (var lx = GRID_STEP; lx < AREA_W; lx += GRID_STEP) {
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText(lx + ' cm', lx * pxPerCm + 4, 15);
      ctx.fillStyle = '#253952';
      ctx.fillText(lx + ' cm', lx * pxPerCm + 3, 14);
    }
    for (var ly = GRID_STEP; ly < AREA_H; ly += GRID_STEP) {
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText(ly + ' cm', 5, ly * pxPerCm - 3);
      ctx.fillStyle = '#253952';
      ctx.fillText(ly + ' cm', 4, ly * pxPerCm - 4);
    }

    // --- Border ---
    ctx.strokeStyle = '#161e25';
    ctx.lineWidth = 2;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);
  }

  function openModal(btn) {
    var modalId  = btn.dataset.modal;
    var modal    = document.getElementById(modalId);
    if (!modal) return;

    var canvas   = modal.querySelector('.ff-pm-canvas');
    var wrap     = modal.querySelector('.ff-pm-canvas-wrap');
    var loader   = modal.querySelector('.ff-pm-loader');
    var repeatW  = parseFloat(btn.dataset.repeatWidth)  || 30;
    var repeatH  = parseFloat(btn.dataset.repeatHeight) || 30;
    var imageUrl = btn.dataset.image;
    if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (loader) loader.hidden = false;

    requestAnimationFrame(function () {
      canvas.width = wrap.clientWidth || 600;

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        drawPattern(canvas, img, repeatW, repeatH);
        if (loader) loader.hidden = true;
      };
      img.onerror = function () {
        if (loader) loader.textContent = 'Could not load image.';
      };
      img.src = imageUrl;
    });
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function init() {
    document.querySelectorAll('.ff-pattern-btn[data-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(btn); });
    });

    document.querySelectorAll('.ff-pattern-modal').forEach(function (modal) {
      modal.querySelector('.ff-pm-overlay').addEventListener('click', function () { closeModal(modal); });
      modal.querySelector('.ff-pm-close').addEventListener('click',   function () { closeModal(modal); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.ff-pattern-modal:not([hidden])').forEach(function (m) { closeModal(m); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
